import { ContactAndTravelerActions } from "@apac/checkout";
import {
  ContactInformationActions,
  CartActions,
  CardPaymentActions,
  PassengerActions,
  getObjectKeysAsObject,
  ReviewActions,
  ActivitiesActions,
} from "@hopper-b2b/checkout";
import { BookingConfirmationActions } from "@/modules/checkout/states/BookingConfirmation";
import { ContactAndTravellerActionsOverrides } from "@/modules/checkout/states/ContactAndTraveller";
import { RewardsPaymentActions } from "@/modules/checkout/states/Rewards";
import { TermsAndConditionsActions } from "@/modules/checkout/states/TermsAndConditions";

export const Actions = {
  ...CartActions,
  ...ContactInformationActions,
  ...PassengerActions,
  ...CardPaymentActions,
  ...ActivitiesActions,
  ...ContactAndTravelerActions,
  ...ContactAndTravellerActionsOverrides,
  ...RewardsPaymentActions,
  ...ReviewActions,
  ...TermsAndConditionsActions,
  ...BookingConfirmationActions,
};

export const ActionTypes = getObjectKeysAsObject(Actions);
